import React from 'react';

const TableHead = props => (
    <thead>
        {props.children}
    </thead>
);

export default TableHead;